module.exports = __webpack_public_path__ + "img/Iraqi-Kurdistan.97db9034.png";